import WebOperationModelBase from '../_generated/modelBases/web-operation-model-base';

export default class WebOperationModel extends WebOperationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
